<!--日三十分钟表格-->
<template>
  <div>
    <el-table :data="dataList" height="795" border style="width: 100%;" v-loading="loading">
      <template slot="empty">
        <span class="noData">
          <img src="../../../assets/noData.png" alt="暂无数据">
          <span class="text">暂无数据</span>
        </span>
      </template>
      <el-table-column type="index" width="50" fixed>
      </el-table-column>
      <el-table-column prop="variablename" label="变量名" width="200" fixed>
      </el-table-column>
      <el-table-column prop="next" label="next" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.next" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0000" label="value0000" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0000" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0030" label="value0030" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0030" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0100" label="value0100" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0100" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0130" label="value0130" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0130" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0200" label="value0200" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0200" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0230" label="value0230" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0230" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0300" label="value0300" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0300" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0330" label="value0330" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0330" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0400" label="value0400" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0400" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0430" label="value0430" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0430" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0500" label="value0500" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0500" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0530" label="value0530" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0530" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0600" label="value0600" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0600" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0630" label="value0630" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0630" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0700" label="value0700" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0700" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0730" label="value0730" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0730" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0800" label="value0800" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0800" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0830" label="value0830" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0830" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0900" label="value0900" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0900" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value0930" label="value0930" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value0930" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1000" label="value1000" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1000" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1030" label="value1030" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1030" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1100" label="value1100" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1100" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1130" label="value1130" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1130" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1200" label="value1200" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1200" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1230" label="value1230" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1230" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1300" label="value1300" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1300" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1330" label="value1330" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1330" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1400" label="value1400" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1400" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1430" label="value1430" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1430" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1500" label="value1500" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1500" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1530" label="value1530" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1530" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1600" label="value1600" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1600" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1630" label="value1630" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1630" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1700" label="value1700" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1700" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1730" label="value1730" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1730" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1800" label="value1800" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1800" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1830" label="value1830" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1830" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1900" label="value1900" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1900" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value1930" label="value1930" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value1930" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2000" label="value2000" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2000" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2030" label="value2030" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2030" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2100" label="value2100" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2100" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2130" label="value2130" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2130" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2200" label="value2200" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2200" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2230" label="value2230" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2230" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2300" label="value2300" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2300" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="value2330" label="value2330" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.value2330" placeholder="请输入"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="singleDetermine(scope.row)" plain>确定修改</el-button>
          <el-button type="primary" size="mini" @click="average(scope.row)">首尾平均</el-button>
          <el-button type="primary" size="mini" @click="increment(scope.row)">自动增量</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    props: {
      dataList: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    created () {},
    mounted () {},
    destroyed () {},
    computed: {},
    watch: {},
    methods: {
      singleDetermine (data) {
        this.$emit("singleDetermine",data)
      },
      timeFormat (value) {
        let formatValue=0
        let hour=parseInt(value/60)
        let minute=value%60
        if(hour<10) {
          hour='0'+hour
        }
        if(minute!=0) {
          formatValue=hour+(minute).toString()
        } else {
          formatValue=hour+'00'
        }
        return formatValue
      },
      average (row) {
        let first=row['value0000']
        let tail=row['next']
        if(tail!='-1.1111'&&!isempty(tail)&&first!='-1.1111'&&!isempty(first)) {
          let difference=((tail-first)/48).toFixed(3)
          let onValue=0
          for(let i=30;i<1440;i+=30) {
            let time=this.timeFormat(i)
            let oneTime=this.timeFormat(i-30)
            onValue=Number(row['value'+oneTime])
            if(onValue==-1.1111) {
              onValue=0
            }
            row['value'+time]=(onValue+Number(difference)).toFixed(3)

          }
          //将值找到再替换
        } else {
          this.$message.error("首值或者尾值不能为空")
        }
      },
      increment (row) {
        let first=row['value0000']
        let two=row['value0030']
        if(two!='-1.1111'&&!isempty(two)&&first!='-1.1111'&&!isempty(first)) {
          let difference=(two-first).toFixed(3)
          let onValue=0
          for(let i=60;i<1440;i+=30) {
            let time=this.timeFormat(i)
            let oneTime=this.timeFormat(i-30)
            onValue=Number(row['value'+oneTime])
            if(onValue==-1.1111) {
              onValue=0
            }
            row['value'+time]=(onValue+Number(difference)).toFixed(3)
          }
        } else {
          this.$message.error("第一值和第二值不能为空")
        }
      }
    }
  }
</script>

<style scoped>

</style>